export const TAG_GET_FULL_CALENDAR_YEAR_PERIODS = 'TAG_GET_FULL_CALENDAR_YEAR_PERIODS'

export default [TAG_GET_FULL_CALENDAR_YEAR_PERIODS]
